// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__HZ00M","signatureButtonsRight":"ModalSign_signatureButtonsRight__3mQ-W"};